// recon-other-messages translations (English catalog).
window.PlummeI18n.register('en', {
  'rco.age.d0to30': '0–30 days',
  'rco.age.d31to60': '31–60 days',
  'rco.age.d61to90': '61–90 days',
  'rco.age.over90': 'Over 90 days',
  'rco.age.noDate': 'No date',
  'rco.noText': 'No text',
  'rco.type.liability': 'Liability',
  'rco.type.asset': 'Asset',
  'rco.check.specVsLedger': 'Specified items vs the general ledger',
  'rco.check.notFullySpecified': 'The balance is not fully specified',
  'rco.check.sumsToLedger': 'Adds up to the general ledger',
  'rco.check.older90': 'Items older than 90 days',
  'rco.check.noCounterparty': 'Items without an identified counterparty',
  'rco.check.unusualSign': 'Items with an unusual sign',
  'rco.check.noMovement': 'Items with no movement in the period',
  'rco.check.manualAtPeriodEnd': 'Manual postings at period end',
  'rco.check.roundAmounts': 'Round amounts',
});
